<template>
  <div class="container">
    <el-tabs v-model="activeName">
      <el-tab-pane
        :label="item.label"
        :name="item.name"
        v-for="(item, index) in tabs"
        :key="index"
      >
      </el-tab-pane>
    </el-tabs>
    <dataFilling
      v-if="activeName == '1' && active == ''"
      :active.sync="active"
    />
    <expert v-if="activeName == '2'" />
    <dataReview
      v-if="activeName == '1' && active !== ''"
      :active.sync="active"
    />
    <!-- <dataReview v-if="activeName == '1'" :active.sync="active" /> -->
  </div>
</template>

<script>
import fileDownload from "js-file-download";
import dataFilling from "./data.vue";
import expert from "./expert.vue";
import dataReview from "./dataReview.vue";
export default {
  data() {
    return {
      activeName: "1",
      active: "",
      tabs: [],
      userName: "admin",
    };
  },
  created() {
    let user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      if (
        user.username == "admin" ||
        user.username == "刘飞蝶" ||
        user.username == "情报所"
      ) {
        this.tabs = [
          {
            label: "评审填报管理",
            name: "1",
          },
          {
            label: "专家管理",
            name: "2",
          },
        ];
      } else {
        this.tabs = [
          {
            label: "评审填报管理",
            name: "1",
          },
        ];
      }
    }
  },
  methods: {},
  components: {
    dataFilling,
    expert,
    dataReview,
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  background: #fff;
  margin: 0;
  padding: 20px;
  box-sizing: border-box;
  min-height: 700px;
  position: relative;
}
::v-deep .el-tabs__nav-wrap::after {
  background: #fff;
}
</style>
